import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MentionUser } from './components/mention-dropdown/mention-dropdown.component';

export interface UserSearchParams {
  q: string;
}

export interface UserSearchResponse {
  items: MentionUser[];
}

export interface UserSearchProvider {
  findAll(params: UserSearchParams): Observable<UserSearchResponse>;
}

export const USER_SEARCH_PROVIDER = new InjectionToken<UserSearchProvider>(
  'USER_SEARCH_PROVIDER'
);
